import React, { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import {
  Box,
  Text,
  Image,
  Container,
  Flex,
  Heading,
  VStack,
  Spacer,
  Stack,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Link,
} from '@chakra-ui/react';

import { SupportScreen } from './supportScreen';
import BtButton from '../../components/BtButton';
import { images } from '../../support/imageSupport';
import BtHelmet from '../../components/BtHelmet';
import BtLoading from '../../components/BtLoading';
import { useSelector } from 'react-redux';
import { RootState } from '../../app/store';

export const Support: React.FC = () => {
  const viewModel = useAppSelector((state) => state.support.viewModel);
  const dispatch = useAppDispatch();
  const logoUrl = useSelector((state: RootState) => state.gatInformation.logoUrl);

  useEffect(() => {
    if (SupportScreen.isNone(viewModel)) {
      dispatch(SupportScreen.start(viewModel));
    } else if (SupportScreen.isLoading(viewModel)) {
      (async () => {
        dispatch(await SupportScreen.load(viewModel));
      })();
    }
  }, [viewModel]);

  const handleclose = async () => {
    dispatch(await SupportScreen.close(viewModel, logoUrl));
  };

  if (SupportScreen.isLoading(viewModel)) {
    return (
      <Container padding={0} size='xl'>
        <Container padding={0} maxW='container.md'>
          <Flex pb={200}>
            <VStack w='full' h='full' p={10}>
              <Box w='100%' p={4} bg='black' borderRadius='lg'>
                <VStack spacing='5' w='100%'>
                  <Stack
                    w='full'
                    spacing={5}
                    direction={['row', 'column']}
                    p={5}
                    alignItems='center'
                  >
                    <Text>Laddar...</Text>
                    <Spacer />
                  </Stack>
                </VStack>
              </Box>
            </VStack>
          </Flex>
        </Container>
      </Container>
    );
  } else if (SupportScreen.isReady(viewModel)) {
    return (
      <>
        <BtHelmet title={viewModel.metaTitle} />
        <Modal isOpen={true} onClose={() => handleclose()} isCentered size='xl'>
          <ModalOverlay bg='rgba(0, 0, 0, 0.6)' backdropFilter='auto' backdropBlur='2px' />
          <ModalContent bg='black'>
            <Box w='100%' p={4} bg='black' borderRadius='lg' boxShadow='brand'>
              <Flex>
                <Spacer />
                <BtButton
                  variant='ghost'
                  size=''
                  w=''
                  {...viewModel.close}
                  action={() => handleclose()}
                />
              </Flex>
              <VStack spacing='5' w='100%'>
                <Heading as='h1' variant='h1'>
                  {viewModel.title}
                </Heading>
                <ModalBody>
                  <Text>{viewModel.body}</Text>
                  <Stack spacing={5} direction={['row', 'row']} p={5} alignItems='center'>
                    <Image src={images(viewModel.ikon)} />
                    <Link href={`tel:+${viewModel.phone}`} color='brand.500'>
                      {viewModel.phone}
                    </Link>
                  </Stack>
                </ModalBody>
              </VStack>
            </Box>
          </ModalContent>
        </Modal>
      </>
    );
  } else {
    return <BtLoading {...viewModel.loading} />;
  }
};
